import ajax from './index'
import apiEnv from './apiEnv'
// 已发帖子列表
export function getListPublishedPost(data) {
    return ajax.post(`${apiEnv.api4}/api/ForumPost/ListPublishedPost`, data)
}
// 获取帖子分类
export function GetPostCategory(data) {
    return ajax.post(`${apiEnv.api1}/api/ForumPost/GetPostCategory`, data)
}
// 帖子详情
export function GetPostDetail(data) {
    return ajax.post(`${apiEnv.api4}/api/ForumPost/GetPostDetail`, data)
}
// 帖子评论
export function GetPostCommentList(data) {
    return ajax.post(`${apiEnv.api4}/api/ForumPostComment/GetPostCommentList`, data)
}
//添加获取释放,取消原因接口 || 删除原因
export function GetOperationReason(data) {
    return ajax.post(`${apiEnv.api1}/JobWorkflow/PickJob/GetOperationReason`, data)
}
// 删除帖子
export function DeletePost(data) {
    return ajax.post(`${apiEnv.api4}/api/ForumPost/DeletePost`, data)
}
// 删除帖子评论
export function DeletePostComment(data) {
    return ajax.post(`${apiEnv.api4}/api/ForumPostComment/DeletePostComment`, data)
}
// 获取举报帖子列表
export function ListPostComplaint(data) {
    return ajax.post(`${apiEnv.api4}/api/ForumPostComplaint/ListPostComplaint`, data)
}
// 处理举报 删除 || 不删除
export function DealPostComplaint(data) {
    return ajax.post(`${apiEnv.api4}/api/ForumPostComplaint/DealPostComplaint`, data)
}
// 切换帖子是否本人可见
export function SwitchPostIsAuthorView(data) {
    return ajax.post(`${apiEnv.api4}/api/ForumPost/SwitchPostIsAuthorView`, data)
}



// 获取奖品状态列表
export function GetPrizeStatus(data) {
    return ajax.post(`${apiEnv.api4}/api/AccPrize/GetPrizeStatus`, data)
}
// 获取奖品列表
export function GetPrizeList(data) {
    return ajax.post(`${apiEnv.api4}/api/AccPrize/GetPrizeList`, data)
}
// 设置奖品上线、下线、删除、恢复
export function SetPrizeStatus(data) {
    return ajax.post(`${apiEnv.api4}/api/AccPrize/SetPrizeStatus`, data)
}
// 奖品列表的上移下移
export function SetSortNo(data) {
    return ajax.post(`${apiEnv.api4}/api/AccPrize/SetSortNo`, data)
}
// 保存奖品
export function SavePrize(data) {
    return ajax.post(`${apiEnv.api4}/api/AccPrize/SavePrize`, data)
}

// 获取获奖用户数量
export function GetAccPrizeCount(data) {
    return ajax.post(`${apiEnv.api4}/api/AccPrize/GetAccPrizeCount`, data)
}
// 获取获奖列表
export function GetAccPrizeList(data) {
    return ajax.post(`${apiEnv.api4}/api/AccPrize/GetAccPrizeList`, data)
}
// 批量发货
export function GroupGiveOut(data) {
    return ajax.post(`${apiEnv.api4}/api/AccPrize/GroupGiveOut`, data)
}






//论坛活动
// 设置直播视频
export function SetVideo(data) {
    return ajax.post(`${apiEnv.api4}/api/ServiceForum/SetLiveStreamingVideoUrl`, data)
}
//设置直播时间
export function SetVideoTime(data) {
    return ajax.post(`${apiEnv.api4}/api/ServiceForum/SetStartTime`, data)
}
//获取PV UV数据
export function getPUVdata(data) {
    return ajax.post(`${apiEnv.api4}/api/ServiceForum/GetServiceForumStatisticsInfo`, data)
}
//获取直播信息
export function getVideoInfo(data) {
    return ajax.post(`${apiEnv.api4}/api/ServiceForum/GetServiceFormInfo`, data)
}
//设置锦鲤号码
export function setPrizeNo(data) {
    return ajax.post(`${apiEnv.api4}/api/ServiceForum/SetWinPrizeNo`, data)
}
//获取预热视频和大咖观点列表
export function getListData(data) {
    return ajax.post(`${apiEnv.api4}/api/ServiceForum/ListServiceForumVideo`, data)
}
//赞助商列表
export function getListSponsor(data) {
    return ajax.post(`${apiEnv.api4}/api/ServiceForum/ListSponsor`, data)
}
//上传预热视频
export function setuploadVideo(data) {
    return ajax.post(`${apiEnv.api4}/api/ServiceForum/AddOrEditServiceForumVideo`, data)
}
//删除预热视频
export function deleteListVideo(data) {
    return ajax.post(`${apiEnv.api4}/api/ServiceForum/DeleteServiceForumVideo`, data)
}
//上下移预热视频、大咖
export function moveListVideo(data) {
    return ajax.post(`${apiEnv.api4}/api/ServiceForum/UpdateServiceForumVideoSortNo`, data)
}
//赞助商
export function moveListYQ(data) {
    return ajax.post(`${apiEnv.api4}/api/ServiceForum/UpdateSponsorSortNo`, data)
}
//新增赞助商
export function setSponsor(data) {
    return ajax.post(`${apiEnv.api4}/api/ServiceForum/AddOrEditSponsor`, data)
}
//删除赞助商
export function deleteSponsor(data) {
    return ajax.post(`${apiEnv.api4}/api/ServiceForum/DeleteSponsor`, data)
}

//获取工程师大赛用户
export function getActivityUserList(data) {
    return ajax.post(`${apiEnv.api4}/api/EngineerCompetition/GetActivityUserList`, data)
}

//获取工程师大赛用户的考试列表
export function getActVideoExamResoultList(data) {
    return ajax.post(`${apiEnv.api4}/api/EngineerCompetition/GetActVideoExamResoultList`, data)
}

//打分
export function setVideoScore(data) {
    return ajax.post(`${apiEnv.api4}/api/EngineerCompetition/SetVideoScore`, data)
}

//视频考试下载
export function getDownVideoExamUrl() {
    return `${apiEnv.api4}/api/EngineerCompetition/DownActivityUserList`;
}

//获取企业的指标列表
export function GetCompanyTargetList(data) { 
    return ajax.post(`${apiEnv.api4}/api/CompanyTargetAmount/GetCompanyTargetList`, data)
}
//获取企业的指标列表
export function UpdateCompanytTarget(data) {
    return ajax.post(`${apiEnv.api4}/api/CompanyTargetAmount/UpdateCompanytTarget`, data)
}

//获取群聊质检的配置信息
export function getComWxGroupMonitorConfig(data) {
    return ajax.post(`${apiEnv.api4}/api/ComWeChat/ComWeChatLog/GetComWxGroupMonitorConfig`, data)
}
 
//保存群聊质检配置
export function saveComWxGroupMonitorConfig(data) {
    return ajax.post(`${apiEnv.api4}api/ComWeChat/ComWeChatLog/SaveComWxGroupMonitorConfig`, data)
}

 













































// 人员管理 接口->liuBo
// 个人用户列表
export function userBindingList(data) {
    return ajax.post(`${apiEnv.api2}/gz/admin/jobNumberBinding/userBindingList`, data)
}
// 搜搜公司
export function searchCompanys(data) {
    return ajax.post(`${apiEnv.api2}/gz/admin/jobNumberBinding/searchCompanys`, data)
}
// 搜索用户
export function searchUsers(data) {
    return ajax.post(`${apiEnv.api2}/gz/admin/jobNumberBinding/searchUsers`, data)
}
// 新增绑定
export function addBinding(data) {
    return ajax.post(`${apiEnv.api2}/gz/admin/jobNumberBinding/addBinding`, data)
}
// 企业用户列表
export function companyBindingList(data) {
    return ajax.post(`${apiEnv.api2}/gz/admin/jobNumberBinding/companyBindingList`, data)
}
// 删除绑定
export function deleteBinding(data) {
    return ajax.get(`${apiEnv.api2}/gz/admin/jobNumberBinding/deleteBinding`, data)
}


// 红包抽奖控制
// 活动方案列表
export function redEnvDrawList(data) {
    return ajax.post(`${apiEnv.api2}/redEnvDraw/config/list`, data)
}
// 新增/修改方案
export function redEnvDrawAdd(data) {
    return ajax.post(`${apiEnv.api2}/redEnvDraw/config/addOrUpd`, data)
}
// 删除方案
export function redEnvDrawDel(data) {
    return ajax.get(`${apiEnv.api2}/redEnvDraw/config/del`, data)
}
// 添加生效人群
export function redEnvDrawUserAdd(data) {
    return ajax.post(`${apiEnv.api2}/redEnvDraw/drawUser/add`, data)
}
// 删除生效人群
export function redEnvDrawUserDel(data) {
    return ajax.get(`${apiEnv.api2}/redEnvDraw/drawUser/del`, data)
}
// 上传生效人群
export function redEnvDrawExcelImport(data) {
    return ajax.post(`${apiEnv.api2}/redEnvDraw/excelImport`, data)
}
// 意见反馈列表
export function feedBackList(data) {
    return ajax.post(`${apiEnv.api2}/feedBack/list`, data)
}